module.exports = __webpack_public_path__ + "5528a872b054b09f8aadc89286e4a08b.png";